module.exports = __webpack_public_path__ + "static/media/pic_winie2_08.75415393.png";